import React, { FC } from 'react';
import { Stack } from 'components/stack/stack';

type Props = {
  inline?: boolean;
};

export const RatingBadgesGroup: FC<Props> = ({ inline, children }) => {
  return (
    <Stack
      display={inline ? 'flex' : undefined}
      flow={inline ? undefined : 'row'}
      gap={1}
      alignItems={'flex-start'}
      templateColumns={inline ? undefined : '100px 100px'}
      style={{
        overflowX: inline ? 'auto' : 'unset',
        marginBottom: 12,
      }}
    >
      {children}
    </Stack>
  );
};
